import React from "react";
import { Link, useLocation } from "react-router-dom";
import logoImg from "../assets/logo_transparent.png";

const Logo = ({ size = "md", className = "" }) => {
  const heights = {
    sm: "h-20 md:h-24",
    md: "h-14 md:h-16",
    lg: "h-28 md:h-40",
  };
  return (
    <img
      src={logoImg}
      alt="BY Döner Stuttgart"
      className={`${heights[size]} w-auto object-contain ${className}`}
      data-testid="brand-logo"
      draggable={false}
    />
  );
};

const Navbar = () => {
  const location = useLocation();
  const links = [
    { href: "/#about", label: "Über Uns" },
    { href: "/#hours", label: "Öffnungszeiten" },
    { href: "/#menu", label: "Speisekarte" },
    { href: "/#contact", label: "Kontakt" },
  ];

  const handleClick = (href, e) => {
    if (location.pathname !== "/" && href.startsWith("/#")) return;
    if (href.startsWith("/#")) {
      e.preventDefault();
      const id = href.slice(2);
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b-2 border-red-600/50" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link" className="flex items-center">
          <Logo size="sm" />
        </Link>
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleClick(l.href, e)}
              className="uppercase text-sm tracking-widest text-white/80 hover:text-red-500 transition-colors relative group"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, '-').replace(/ö/g, 'o')}`}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-red-600 group-hover:w-full transition-all duration-300"></span>
            </a>
          ))}
          <a
            href="tel:+4971175486846"
            className="px-5 py-2 bg-red-600 hover:bg-red-700 text-white uppercase text-sm tracking-widest font-semibold transition-colors"
            data-testid="nav-call-btn"
          >
            Bestellen
          </a>
        </div>
      </div>
    </nav>
  );
};

export { Logo };
export default Navbar;
